// Search-panel schema for the IM Enter Transaction Find screen (Delphi uIMD0019).
//
// Dedicated to this screen rather than borrowing im/itemManagement/transactionsTab/
// TransactionsFormLayout.js, which was built for the Item Management transactions grid. Sharing it
// meant this screen's criteria had to match that grid's, which is why Record #, the user-defined
// Date/Quantity fields and the audit columns had no search fields at all.
//
// tableName is IMTRANSACTIONHEADER on every field so the labels resolve through Localization the way
// the rest of the screen's fields do; the borrowed layout passed "" and bypassed it entirely.
const TABLE = "IMTRANSACTIONHEADER";

const f = (name, label, type, visible, options) => ({
    name,
    tableName: TABLE,
    label,
    type,
    options: options || null,
    apiUrl: null,
    grid: null,
    required: false,
    visible,
    isLabelChanged: false,
});

const series = (prefix, label, type, from, to, visible = false) =>
    Array.from({ length: to - from + 1 }, (_, i) => f(`${prefix}${from + i}`, `${label} - ${from + i}`, type, visible));

export const TransactionSearchLayout = [
    // Delphi's four Find criteria lead: Record #, Trans Type, Trans Date, Reference #.
    {
        groupId: 1,
        label: "",
        fields: [
            f("KeySequence", "Record #", "number", true),
            f("TransactionType", "Trans Type", "select", true),
            f("Stage", "Stage", "select", true),
            ...series("Code", "Code", "text", 1, 3),
        ],
    },
    {
        groupId: 2,
        label: "",
        fields: [
            f("Status", "Status", "select", true),
            f("OpenStatusOnly", "Open Status Only", "checkbox", true),
            f("TransactionDateFrom", "Trans Date From", "date", true),
            f("TransactionDateTo", "Trans Date To", "date", true),
            ...series("Code", "Code", "text", 4, 6),
        ],
    },
    {
        groupId: 3,
        label: "",
        fields: [
            f("Reference", "Reference #", "text", true),
            f("ProfileCode", "Profile", "text", true),
            // Plain text, not a textarea: this is a filter, not the record's Description field.
            f("Description", "Description", "text", true),
            ...series("Code", "Code", "text", 7, 10),
        ],
    },
    {
        groupId: 4,
        label: "",
        fields: [
            // Shown as a pair - previously Fiscal Year was visible and Fiscal Period was not.
            f("FiscalYear", "Fiscal Year", "number", true),
            f("FiscalPeriod", "Fiscal Period", "number", true),
            f("ImportFileName", "Name", "text", false),
            f("Comment", "Comment", "text", false),
            f("UserDefinedComment", "User Comment", "text", false),
        ],
    },
    // Audit and commit criteria, matching the Find columns of the same names. Hidden by default and
    // reachable through the form's field chooser, like the user-defined series below.
    {
        groupId: 5,
        label: "",
        fields: [
            f("CreationDateFrom", "Creation Date From", "date", false),
            f("CreationDateTo", "Creation Date To", "date", false),
            f("CreationUserId", "Created By", "text", false),
            f("LastUpdateDateFrom", "Last Updated From", "date", false),
            f("LastUpdateDateTo", "Last Updated To", "date", false),
            f("LastUpdateUserId", "Last Updated By", "text", false),
            f("CommitDateFrom", "Commit Date From", "date", false),
            f("CommitDateTo", "Commit Date To", "date", false),
        ],
    },
    // User-defined passthrough criteria, one per grid column of the same name.
    {
        groupId: 6,
        label: "",
        fields: [
            ...series("Reference", "Reference", "text", 1, 10),
            ...series("Date", "Date", "date", 1, 10),
            ...series("Quantity", "Quantity", "number", 1, 10),
        ],
    },
];

export default TransactionSearchLayout;
